import { bootstrapApplication } from '@angular/platform-browser';
import { config } from './app/app.config.browser';
import { App } from './app/app';
import { initializeEmojiDetector } from './app/shared/utils/emoji-detector';
import { initViewportSignals } from './app/shared/utils/viewport.utils';
import { PosthogService } from './app/shared/services/posthog.service';

// Initialize browser-only utilities (protected from SSR)
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeEmojiDetector();
      initViewportSignals();
    });
  } else {
    initializeEmojiDetector();
    initViewportSignals();
  }

  // Lamaquina Recorder — Ctrl+Click component inspector (browser-only, SSR-safe)
  import('lamaquina-recorder');
}

bootstrapApplication(App, config)
  .then((appRef) => {
    // Initialize PostHog after app bootstrap (browser only)
    if (typeof window !== 'undefined') {
      const posthog = appRef.injector.get(PosthogService);
      posthog.init();
    }
  })
  .catch((err) => console.error(err));
